/**
 * Dispatch an error back to the client
 *
 * @public
 * @param {Object} options
 */

export default function dispatchError(options = {}) {

  return function errorHandler(err, req, res, next) {
    const logger = req.logger || console
    if(!logger.debug) {
      logger.debug = console.log.bind(console)
    }

    if(options.debug || process.env.LOG_LEVEL && ['debug', 'error'].indexOf(process.env.LOG_LEVEL) > -1) {
      logger.error('Dispatcher received error', err)
    }

    if(err instanceof Array) {
      err = err[0];
    }

    const code = err.code ? err.code.toUpperCase() : 'UNKNOWN_ERROR'
    const message = err.message || null
    const params = err.params || null
    const status = options.status || err.status || 400

    const debug = (options.debug || process.env.NODE_ENV && process.env.NODE_ENV == 'development' || (process.env.LOG_LEVEL && process.env.LOG_LEVEL == 'debug'))

    res.status(status).json({
      err: {
        error: (debug) ? err.debug || null : null,
        code,
        message,
        params,
        stack: (debug) ? err.stack || null : null,
        url: req.originalUrl
      },
      requestId: req.headers['x-request-id'],
      sentry: res.sentry,
      status
    })

  }

}
